import { create } from "zustand";

export const useAboutStore = create((set) => ({
  aboutOpen: false,
  swap: () => set((state) => ({ aboutOpen: !state.aboutOpen })),
}));
